// extracted by mini-css-extract-plugin
export var connectionButton = "_b3-1";
export var rightPanel = "_b3-3";
export var stepDescription = "_b3-2";
export var stepIcon = "_b3-0";